/* VAGTEC SA — Theme JavaScript */

(function () {
  'use strict';

  // ─── Sticky Header ──────────────────────────────────────
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  // ─── Mobile Menu ────────────────────────────────────────
  const mobileBtn = document.querySelector('.mobile-menu-btn');
  const mobileNav = document.querySelector('.mobile-nav');
  const mobileOverlay = document.querySelector('.mobile-overlay');

  function openMenu() {
    mobileBtn?.classList.add('active');
    mobileNav?.classList.add('open');
    mobileOverlay?.classList.add('active');
    document.body.classList.add('no-scroll');
  }
  function closeMenu() {
    mobileBtn?.classList.remove('active');
    mobileNav?.classList.remove('open');
    mobileOverlay?.classList.remove('active');
    document.body.classList.remove('no-scroll');
  }

  mobileBtn?.addEventListener('click', () => {
    mobileNav?.classList.contains('open') ? closeMenu() : openMenu();
  });
  mobileOverlay?.addEventListener('click', closeMenu);

  // Close on escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeMenu();
  });

  // ─── Quantity Selector ──────────────────────────────────
  document.querySelectorAll('.quantity-selector').forEach(selector => {
    const input = selector.querySelector('.qty-input');
    const minus = selector.querySelector('[data-qty="minus"]');
    const plus = selector.querySelector('[data-qty="plus"]');
    if (!input) return;

    minus?.addEventListener('click', () => {
      const val = parseInt(input.value) || 1;
      if (val > 1) input.value = val - 1;
    });
    plus?.addEventListener('click', () => {
      const val = parseInt(input.value) || 1;
      input.value = val + 1;
    });
    input.addEventListener('change', () => {
      if (parseInt(input.value) < 1 || isNaN(parseInt(input.value))) input.value = 1;
    });
  });

  // ─── Product Image Gallery ──────────────────────────────
  const mainImg = document.querySelector('.product-media__main img');
  const thumbs = document.querySelectorAll('.product-media__thumb');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const src = thumb.querySelector('img')?.src;
      if (mainImg && src) mainImg.src = src;
    });
  });

  // ─── Product Tabs ────────────────────────────────────────
  const tabBtns = document.querySelectorAll('.tab-btn');
  const tabContents = document.querySelectorAll('.tab-content');
  tabBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.tab;
      tabBtns.forEach(b => b.classList.remove('active'));
      tabContents.forEach(c => c.classList.remove('active'));
      btn.classList.add('active');
      document.getElementById(target)?.classList.add('active');
    });
  });

  // ─── Variant Options ────────────────────────────────────
  const optionBtns = document.querySelectorAll('.option-btn');
  optionBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const group = btn.closest('.option-buttons');
      group?.querySelectorAll('.option-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const label = btn.closest('.product-options')?.querySelector('.selected-value');
      if (label) label.textContent = '— ' + btn.textContent.trim();
    });
  });

  // ─── Filter Accordion ───────────────────────────────────
  document.querySelectorAll('.filter-block__header').forEach(header => {
    header.addEventListener('click', () => {
      header.classList.toggle('open');
      const body = header.nextElementSibling;
      if (body) {
        body.style.display = header.classList.contains('open') ? 'block' : 'none';
      }
    });
    // Open first filter by default
    if (header === document.querySelector('.filter-block__header')) {
      header.classList.add('open');
    }
  });

  // ─── Add to Cart Feedback ────────────────────────────────
  document.querySelectorAll('.product-card__add').forEach(btn => {
    btn.addEventListener('click', function () {
      if (this.classList.contains('product-card__add--unavailable')) return;
      const original = this.textContent;
      this.textContent = '✓ Added';
      this.style.background = 'var(--color-success)';
      setTimeout(() => {
        this.textContent = original;
        this.style.background = '';
      }, 1800);
    });
  });

  // ─── Filter Accordion init ──────────────────────────────
  document.querySelectorAll('.filter-block__body').forEach((body, i) => {
    if (i > 0) body.style.display = 'none';
  });

})();
